<template>
  <div class="top-nav">
    <div class="nav-logo"><img src="../../assets/images/logo/logo2.png" /></div>
    <div class="top-submenu">
      <el-menu
        @select="handleSelect"
        class="el-menu-topsub"
        mode="horizontal"
        text-color="#fff"
        style="border-bottom: none; float: right; margin-right: 20px"
        background-color="transparent"
        active-text-color="#red"
        
      >
        <el-menu-item style="border-bottom: none" index="schemacenter" v-if="showSchema">
          <svg-icon name="schema" size="25" />  
        </el-menu-item>
      <!--  <el-menu-item style="border-bottom: none">
          <svg-icon name="message" size="25" />
          <el-badge class="mark" :value="12"
        /></el-menu-item> -->
      
        <el-submenu index="3"  style="border-bottom: none">
          <template
            slot="title"
            style="border-bottom: none; background-color: #3894df;color:#000">
          <span class="avatar" v-show="false">   <img src="../../assets/images/touxiang.png" /> </span>
            {{ adminName }}
 </template>
          <el-menu-item index="chartmgr"  v-if="showSchema">模块管理  </el-menu-item>
          <el-menu-item index="logout">退出登录</el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import Permissions from "@/store/permissions.js";
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "topnav",
  data() {
    return {
      showMenu: false,
      adminName: "guest",
    };
  },
  methods: {
    ...mapMutations(["setLoggedIn"]),
    ...mapActions("user", [
      "getUserConfig",
      "getCurrentLoginInfo",
      "checkPermission",
    ]),
    changeActive($event) {
      this.showMenu = true;
    },
    removeActive($event) {
      this.showMenu = false;
    },
    handleSelect(name) {
      if (name == "logout") {
        this.setLoggedIn(false);
        localStorage.removeItem("ss");
        localStorage.clear();
        this.$router.push({
          name: "login",
        });
      }else if(name=="chartmgr")
      {
          this.$router.push({ name: "chartmgr"});
      }else if(name=="schemacenter")
      {
         this.$router.push({ name: "schemacenter"});
      }
    },
  },
  computed: {
    ...mapGetters("user", ["currentLoginInfo", "userConfig", "token"]),
    showSchema()
    {
     return Permissions.client_view_schema();
    }
  },
  created() {
     this.getUserConfig({handle:null});
     this.getCurrentLoginInfo({handle:null});
  },
  watch: {
    currentLoginInfo(newValue) {
      this.adminName = newValue.user.name;
    },
  },
};
</script>

<style>
.top-nav {
  position: relative;
  width: 100%;
  height: 60px;
  margin-bottom: 10px;
  border: 1px transparent solid;
  background-color: #327ed4;
  background: linear-gradient(to right, #327ed4, #389ae3);
}
.nav-logo {
  /* float: left; */
  position: absolute;
  left: 10px;
  top: 15px;
  margin: 0px 0 0 10px;
}
.nav-logo img {
  height: 30px;
}
.top-submenu {
  /* float: right; */
  position: absolute;
  right: 10px;
  top: 0px;
  max-width: 600px;
}

.el-menu--horizontal > .el-submenu .el-submenu__title{
  background-color: transparent !important;
}
.el-menu--horizontal > .el-submenu .el-submenu__title:hover{
  background-color: transparent !important;
 
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover, .el-menu--horizontal .el-menu-item:not(.is-disabled):focus
{
  background-color: transparent !important;
 
}
.el-submenu__title i {
    color: #fff !important; 
}
.el-menu--popup-bottom-start{
 background-color: #327ed4 !important;
}
</style>
  